import React, { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import axios from 'axios'
import { motion } from 'framer-motion'
import { toast, Toaster } from 'react-hot-toast'
import {API_BASED_URL} from '../config.js'; 

const AddOperator = () => {
    const [operatorId, setOperatorId] = useState('')
    const [password, setPassword] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [showPass, setShowPass] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        try {
            const authToken = localStorage.getItem('userToken')
            
            if (!authToken) {
                throw new Error('Authentication token not found. Please log in.')
            }

            const response = await axios.post(
                `${API_BASED_URL}api/add-operator`,
                { operatorId, password },
                {
                    headers: {
                        Authorization: `${authToken}`,
                        Position: localStorage.getItem('userPosition')
                    },
                }
            )
            
            toast.success('Operator added successfully!')
            setOperatorId('')
            setPassword('')
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error adding operator. Please try again with other email id or contact gargsanyam2004@gmail.com.')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-100 flex items-center justify-center p-4">
            <Toaster position="top-center" reverseOrder={false} />
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="w-full max-w-md"
            >
                <div className="bg-white shadow-md rounded-lg overflow-hidden">
                    <div className="p-6">
                        <h2 className="text-2xl font-bold text-center text-purple-700 mb-2">Add Operator</h2>
                        <p className="text-center text-gray-600 mb-6">Enter the details to add a new operator</p>
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div className="space-y-2">
                                <label htmlFor="operatorId" className="text-sm font-medium text-gray-700 block">Operator ID:</label>
                                <input
                                    id="operatorId"
                                    type="text"
                                    value={operatorId}
                                    onChange={(e) => setOperatorId(e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                                />
                            </div>
                            <div className="space-y-2">
                                <label htmlFor="password" className="text-sm font-medium text-gray-700 block">Password:</label>
                                <div className="relative">
                                    <input
                                        id="password"
                                        type={showPass ? 'text' : 'password'}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 pr-10"
                                    />
                                    <button type="button" aria-label={showPass ? 'Hide password' : 'Show password'} onClick={()=>setShowPass(v=>!v)} className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex w-7 h-7 items-center justify-center p-0.5 rounded-md text-gray-500 hover:text-gray-700 bg-transparent hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500">{showPass ? <EyeOff size={18}/> : <Eye size={18}/>}</button>
                                </div>
                            </div>
                            <button 
                                type="submit" 
                                className={`w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded-md transition duration-300 ease-in-out transform hover:scale-105 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Adding...' : 'Add Operator'}
                            </button>
                        </form>
                    </div>
                    <div className="bg-gray-50 px-4 py-3">
                        <p className="text-center text-gray-600">Note : please send these credentials to operator. Operators can change password after login for security purposes.</p>
                    </div>
                </div>
            </motion.div>
        </div>
    )
}

export default AddOperator

